/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  SetupTaskAssigneeInput,
  SetupTaskAssigneeInput$Outbound,
  SetupTaskAssigneeInput$outboundSchema,
} from "./setuptaskassigneeinput.js";

/**
 * Setup task status.
 */
export const UpdateSetupTaskRequestBodyStatus = {
  Todo: "todo",
  InProgress: "in_progress",
  AwaitingSupport: "awaiting_support",
  Done: "done",
} as const;
/**
 * Setup task status.
 */
export type UpdateSetupTaskRequestBodyStatus = ClosedEnum<
  typeof UpdateSetupTaskRequestBodyStatus
>;

export type UpdateSetupTaskRequestBody = {
  /**
   * Assignee selector. Exactly one of user_id or email must be present and non-empty.
   */
  assignee?: SetupTaskAssigneeInput | undefined;
  /**
   * Clear the current task assignee. Must not be true when assignee is set.
   */
  clearAssignee?: boolean | undefined;
  /**
   * Hide or restore the task.
   */
  hidden?: boolean | undefined;
  /**
   * Setup task status.
   */
  status?: UpdateSetupTaskRequestBodyStatus | undefined;
  /**
   * Stable setup task key.
   */
  taskKey: string;
};

/** @internal */
export const UpdateSetupTaskRequestBodyStatus$outboundSchema: z.ZodMiniEnum<
  typeof UpdateSetupTaskRequestBodyStatus
> = z.enum(UpdateSetupTaskRequestBodyStatus);

/** @internal */
export type UpdateSetupTaskRequestBody$Outbound = {
  assignee?: SetupTaskAssigneeInput$Outbound | undefined;
  clear_assignee?: boolean | undefined;
  hidden?: boolean | undefined;
  status?: string | undefined;
  task_key: string;
};

/** @internal */
export const UpdateSetupTaskRequestBody$outboundSchema: z.ZodMiniType<
  UpdateSetupTaskRequestBody$Outbound,
  UpdateSetupTaskRequestBody
> = z.pipe(
  z.object({
    assignee: z.optional(SetupTaskAssigneeInput$outboundSchema),
    clearAssignee: z.optional(z.boolean()),
    hidden: z.optional(z.boolean()),
    status: z.optional(UpdateSetupTaskRequestBodyStatus$outboundSchema),
    taskKey: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      clearAssignee: "clear_assignee",
      taskKey: "task_key",
    });
  }),
);

export function updateSetupTaskRequestBodyToJSON(
  updateSetupTaskRequestBody: UpdateSetupTaskRequestBody,
): string {
  return JSON.stringify(
    UpdateSetupTaskRequestBody$outboundSchema.parse(updateSetupTaskRequestBody),
  );
}
